import { useSelector } from 'react-redux';
import { getFirewallByShopId } from '../reducers/selectors';

function useFirewall(shopId) {
  return useSelector(state => getFirewallByShopId(state, shopId));
}

export default useFirewall;